<template>
    <div>
        <card-header title="User Document List" icon="fa-print"/>

        <card-body>
            <card-list>
                <search-list-item @action="searchDocuments"/>

                <subheader-list-item title="Reflections" badge="3" icon="fa-file-alt"/>
                    <menu-list-item title="Document P54321" subtitle="Payment Plan #54321" icon="fa-file" badge="3" @action="selectDoc()"/>

                    <menu-list-item title="Document P54321" subtitle="Payment Plan #54321" icon="fa-file" badge="3" @action="selectDoc()"/>

                    <menu-list-item title="Document P54321" subtitle="Payment Plan #54321" icon="fa-file" badge="3" @action="selectDoc()"/>
                <subheader-list-item title="Signed Contracts" icon="fa-pen-nib" badge="8"/>
                    <menu-list-item title="Document P54321" subtitle="Payment Plan #54321" icon="fa-file" badge="3" @action="selectDoc()"/>

                    <menu-list-item title="Document P54321" subtitle="Payment Plan #54321" icon="fa-file" badge="3" @action="selectDoc()"/>

                    <menu-list-item title="Document P54321" subtitle="Payment Plan #54321" icon="fa-file" badge="3" @action="selectDoc()"/>
            </card-list>
        </card-body>
    </div>
</template>


<script>
    import CardHeader from "../../components/common/CardHeader";
    import CardBody from "../../components/common/CardBody";
    import CardList from "../../components/common/CardList";
    import MenuListItem from "../../components/MenuListItem";
    import SubheaderListItem from "../../components/common/SubheaderListItem";
    import SearchListItem from "../../components/common/SearchListItem";

    export default {
        components: {CardHeader, CardBody, CardList, MenuListItem, SubheaderListItem, SearchListItem},
        props: ['card', 'child'],
        methods: {
            searchDocuments: function (q) {
                this.openCard('documents-search', {query: q});
            },
            selectDocument: function(user) {
                this.openCard('signed-contract', {userId: user.id});
            },
            loadUsers: function() {
                console.log('ul: load user list: active');
                console.log('ul: load user list: recent');
                console.log('ul: load user list: new');
                this.setActive();
            },
            reload: function() {
                this.loadUsers();
            },
            setActive: function() {
                let check = (this.child && this.child.definition.component === 'user') ? parseInt(this.child.props.userId) : null;
                this.recentUsers.map(u => u.active=(u.id===check));
                this.activeUsers.map(u => u.active=(u.id===check));
                this.newUsers.map(u => u.active=(u.id===check));
            },
            openCard: function (card, props) {
                this.$emit('open', {card: card, props: props});
            }
        },
        data() {
            return {
                activeUsers: [
                    {
                        id: 2,
                        first_name: 'Scott',
                        last_name: 'Lamont',
                        email: 'test@test.com',
                        email2: 'test2@test2.com',
                        active: false
                    },
                    {
                        id: 3,
                        first_name: 'Derek',
                        last_name: 'Thomas',
                        email: 'derek.thomas@my247ed.com',
                        email2: 'derek.thomas2@my247ed2.com',
                        active: false
                    },
                    {
                        id: 4,
                        first_name: 'Bob',
                        last_name: 'Recent',
                        email: 'tester@replay.com',
                        email2: 'tester2@replay2.com',
                        active: false
                    }
                ],
                newUsers: [
                    {
                        id: 5,
                        first_name: 'Jane',
                        last_name: 'Newbie',
                        email: 'jnewb@clueless.com',
                        active: false
                    },
                    {
                        id: 6,
                        first_name: 'Scott',
                        last_name: 'Lamont',
                        email: 'test@test.com',
                        active: false
                    },
                    {
                        id: 7,
                        first_name: 'Derek',
                        last_name: 'Thomas',
                        email: 'derek.thomas@my247ed.com',
                        active: false
                    },
                    {
                        id: 8,
                        first_name: 'Bob',
                        last_name: 'Recent',
                        email: 'tester@replay.com',
                        active: false
                    },
                    {
                        id: 9,
                        first_name: 'Jane',
                        last_name: 'Newbie',
                        email: 'jnewb@clueless.com',
                        active: false
                    },
                    {
                        id: 10,
                        first_name: 'Scott',
                        last_name: 'Lamont',
                        email: 'test@test.com',
                        active: false
                    },
                    {
                        id: 11,
                        first_name: 'Derek',
                        last_name: 'Thomas',
                        email: 'derek.thomas@my247ed.com',
                        active: false
                    },
                    {
                        id: 12,
                        first_name: 'Bob',
                        last_name: 'Recent',
                        email: 'tester@replay.com',
                        active: false
                    }
                ]
            }
        },
        watch: {
            'child': function() {
                this.setActive();
            }
        },
        mounted: function() {
            this.loadUsers();
        }
    }
</script>

<style lang="scss" scoped>

</style>
